import { invalidateQuery, invalidateQueryExactMatch, noddiAsync, URLKeys } from 'noddi-async';
import { PERSONAL_INFO_REVIEW_MUTATION_KEY } from './types';
import { useUpdateSessionUser } from './useUpdateSessionUser';

/**
 * The one call that stamps the review as done, owned by the flow alone.
 *
 * It carries no payload: every edit in the review is saved by its own endpoint
 * as it happens, so this is a pure "the customer answered everything" marker.
 */
export const useConfirmPersonalInfoMutation = ({ userId }: { userId: number }) => {
  const updateSessionUser = useUpdateSessionUser();

  return noddiAsync.usePost({
    type: URLKeys.postConfirmPersonalInfo,
    queryConfig: {
      mutationKey: PERSONAL_INFO_REVIEW_MUTATION_KEY,
      onSuccess: (response) => {
        updateSessionUser(response.data);
        invalidateQueryExactMatch({ urlKey: URLKeys.getAccount, input: { userId } });
        invalidateQuery({ urlKey: URLKeys.getUserGroupAddresses });
      }
    }
  });
};
